import SmoothScroll from 'smooth-scroll';

export const smoothScroll = () => {
    const selector = '[data-scroll]';
    if (document.querySelectorAll(selector).length > 0) {
        new SmoothScroll(selector)
    }
};
